var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { SerializeGraphUtils } from './serialize-graph-utils';
/* Serialize the Scene Graph for Module File Export
*/
export function serializeGraph(namespaceMap, excludeMap, overwrite, replaceObjectId) {
    if (replaceObjectId === void 0) { replaceObjectId = false; }
    var rootObjects = Human.scene.rootObjects;
    var sceneGraph = [];
    Object.entries(rootObjects).forEach(function (_a) {
        var _b = __read(_a, 2), id = _b[0], rootObject = _b[1];
        var rootNode = SerializeGraphUtils.serializeHumanObject(rootObject, namespaceMap, overwrite, excludeMap, replaceObjectId);
        if (rootNode !== null) {
            sceneGraph.push(rootNode);
        }
    }, this);
    return sceneGraph;
}
